import output from "_src/engine/output";
import Slicer from "_src/engine/packers/slicer";
import Zipper from "_src/engine/packers/zipper";
import {arrayToString, isDataZipped} from "_src/utils";
import downloader from "_src/engine/loaders/downloader";

const data = new Map();

let slicePacker = new Slicer();
let zipPacker = new Zipper();
let currentPacker = null;

export default {
  ZIP: 1,
  SLICE: 2,

  async getBuffer(filename, id, controller, progressCallback = null) {
    let containerPromise = data.get(filename);
    if (!containerPromise) {
      containerPromise = downloader.download(filename, controller, downloader.BINARY, progressCallback).then(arrayBuffer => {
        const packer = getPackerBySignature(arrayBuffer);
        return packer.unpackData(arrayBuffer);
      });
      data.set(filename, containerPromise);
    }

    const buffersData = await containerPromise;

    if (id >= buffersData.length) {
      output.error(output.DEVELOPERS_ERROR, "Can't load object with id " + id + " . Container " + filename + " has only " + buffersData.length + " objects");
      return;
    }
    return buffersData[id];
  },

  packBuffers(buffers, packerNum = null) {
    let packer = null;

    switch (packerNum) {
      case this.ZIP:
        packer = zipPacker;
        break;
      case this.SLICE:
        packer = slicePacker;
        break;
      default:
        packer = currentPacker;
        break;
    }

    return packer.packData(buffers);
  },

  releaseContainer(filename) {
    data.delete(filename);
  },

  getBufferType(data) {
    return arrayToString(new Uint8Array(data.slice(0, 4)));
  },

  cleanup() {
    data.clear();
  }

}

function getPackerBySignature(packedContainer) {
  if (isDataZipped(packedContainer)) {
    currentPacker = zipPacker;
    return zipPacker;
  } else {
    currentPacker = slicePacker;
    return slicePacker;
  }
}
